interface IndeterminateProgressProps {
  className?: string;
}

function IndeterminateProgress({ className }: IndeterminateProgressProps) {
  return (
    <div className={className}>
      <div className="h-1.5 w-full overflow-hidden bg-blue-dark/10">
        <div className="left-right h-full w-full animate-progress-indeterminate bg-blue-dark"></div>
      </div>
    </div>
  );
}

export default IndeterminateProgress;
